module.exports = __webpack_public_path__ + "static/img/application_6.4536fcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/application/application_6.jpg
// module id = tDpC
// module chunks = 1